/*
 * Shared Messages
 *
 * This contains global messages.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  firstName: {
    id: 'covert.shared.firstName.label',
    sid: 'firstName',
  },
  firstNameValidationEmpty: {
    id: 'covert.shared.firstName.firstNameValidationEmpty',
  },
  firstNameLengthValidation: {
    id: 'covert.shared.firstName.firstNameLengthValidation',
  },
  lastName: {
    id: 'covert.shared.lastName.label',
    sid: 'lastName',
    description: 'Form label for first name',
  },
  lastNameValidationEmpty: {
    id: 'covert.shared.lastName.lastNameValidationEmpty',
  },
  lastNameLengthValidation: {
    id: 'covert.shared.lastName.lastNameLengthValidation',
  },
  email: {
    id: 'covert.shared.email.label',
    sid: 'email',
    description: 'Form label for email',
  },
  emailValidationEmpty: {
    id: 'covert.shared.email.emailValidationEmpty',
  },
  emailValidationIncorrect: {
    id: 'covert.shared.email.emailValidationIncorrect',
  },
  frenchLocaleLabel: {
    id: 'covert.shared.locale.fr',
    description: 'Language label for French',
    defaultMessage: 'Franҫais',
  },
  englishLocaleLabel: {
    id: 'covert.shared.locale.en',
    description: 'Language label for English',
    defaultMessage: 'English',
  },
  canadaLabel: {
    id: 'covert.shared.canada.label',
    description: 'Country name for Canada, used to harden/lock the input value for address country ',
    defaultMessage: 'Canada',
  },
})



// WEBPACK FOOTER //
// ./src/containers/sharedMessages.js